export const percentageFormater = (value:string, decimals:boolean,  rounding = 2) => {
    if (decimals) {
        value = parseFloat(value).toFixed(rounding);
    }
    return value + ' %';
}  